@if (show) {
  @for (each of loaderItems(10); track each) {
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
        height: '40px',
        margin: '0',
        borderRadius: '0',
      }" />
  }
}
